import React, {useEffect} from "react";
import {
    Form, Button, Container, Row, Col, Card, Navbar, Offcanvas,
} from "react-bootstrap";
import "./LaborerMaster.css";
import {useNavigate} from "react-router-dom";
import {useForm} from "react-hook-form";
import {useState} from "react";
import Modal from "react-bootstrap/Modal";
import CheckInimg from "../../../images/CheckInimg.png";
import {confirmAlert} from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import AOS from "aos";
import "aos/dist/aos.css";
import axios from "../../util/Axios/AxiosInstance";
import {toast} from 'react-toastify';
import {formatIdentifier, emptyToNull, normalizeOptionalNumericField} from "./formatIdentifiers";

const GENERIC_LABOUR_SAVE_ERROR =
    "Unable to save labour details. Please verify the entered values and try again.";

const getSafeErrorMessage = (message, fallback = GENERIC_LABOUR_SAVE_ERROR) => {
    if (!message) {
        return fallback;
    }
    const lower = String(message).toLowerCase();
    if (
        lower.includes("sql")
        || lower.includes("hibernate")
        || lower.includes("jdbc")
        || lower.includes("batch")
        || lower.includes("nested exception")
        || lower.includes("master_labour")
        || lower.includes("could not execute")
        || lower.includes("insert into")
        || lower.includes("update master_")
    ) {
        return GENERIC_LABOUR_SAVE_ERROR;
    }
    return message;
};

const isPdfDocument = (previewUrl, fileName, blobType) => {
    if (blobType === "application/pdf") {
        return true;
    }
    const reference = (fileName || previewUrl || "").toLowerCase();
    return reference.endsWith(".pdf");
};

const normalizePreview = (preview) => {
    if (!preview) {
        return null;
    }
    if (typeof preview === "string") {
        return {url: preview, contentType: ""};
    }
    return preview;
};

const renderDocumentPreview = (preview, fileName, label, emptyText = "No Document") => {
    const normalized = normalizePreview(preview);
    if (!normalized?.url) {
        return <div className="p-3 border bg-light text-muted">{emptyText}</div>;
    }

    if (isPdfDocument(normalized.url, fileName, normalized.contentType)) {
        return (
            <iframe
                src={normalized.url}
                title={`${label} Preview`}
                style={{width: "100%", height: "200px", border: "1px solid #ddd"}}
            />
        );
    }

    return (
        <img
            src={normalized.url}
            alt={`${label} Preview`}
            style={{maxWidth: "100%", maxHeight: "200px", objectFit: "contain", border: "1px solid #ddd"}}
            onError={(event) => {
                event.currentTarget.style.display = "none";
            }}
        />
    );
};

function EditLaborerMaster({HandleEvent, data}) {
    const {
        register, handleSubmit, formState: {errors},
    } = useForm();

    const [showLE, setShowLE] = useState(false);
    const [showMsgLE, setShowMsgLE] = useState("");
    const handleClose = () => setShowLE(false);
    const handleBack = (e) => {
        e.preventDefault();
        HandleEvent(2);
    };
    const handleShow = (e) => {
        e.preventDefault();
        setShowLE(true);
    };
    //const showSuccessMsgLE = () => setShowMsgLE(true);

    const navigate = useNavigate();
    const rowData = data;
    const [labourData, setLabourData] = useState(rowData);
    const id = labourData.id;
    const [labourId, setLabourId] = useState(labourData.labourId);
    const [vendorId, setVendorId] = useState(labourData.vendorId);
    const status = labourData.status;
    const [branch, setBranch] = useState(labourData.branch);
    const [branchId, setBranchId] = useState(labourData.branchId);
    const [contractName, setContractName] = useState(labourData.contractName);
    const [vendorName, setVendorName] = useState(labourData.vendorName);
    const [labourName, setLabourName] = useState(labourData.labourName);
    const [addImage, setAddImage] = useState(labourData.addImage);
    const [labourDob, setLabourDob] = useState(formatDateForInput(labourData.labourDob));
    const [labourBloodGroup, setLabourBloodGroup] = useState(labourData.labourBloodGroup);
    const [labourDoj, setLabourDoj] = useState(formatDateForInput(labourData.labourDoj));
    const [gender, setGender] = useState(labourData.gender);
    const [designation, setDesignation] = useState(labourData.designation);
    const [educationalQualification, setEducationalQualification] = useState(labourData.educationalQualification);
    const [adhaarNo, setAdhaarNo] = useState(labourData.adhaarNo);
    const [manpower, setManpower] = useState(labourData.manpower);
    const [address, setAddress] = useState(labourData.address);
    const [pinCode, setPinCode] = useState(labourData.pinCode);
    const [contactNumber, setContactNumber] = useState(labourData.contactNumber);
    const [altNumber, setAltNumber] = useState(labourData.altNumber);
    const [email, setEmail] = useState(labourData.email || "");
    const [altEmail, setAltEmail] = useState(labourData.altEmail || "");
    const [bankState, setBankState] = useState(labourData.bankState);
    const [bankName, setBankName] = useState(labourData.bankName);
    const [accountNo, setAccountNo] = useState(labourData.accountNo);
    const [ifscCode, setIfscCode] = useState(labourData.ifscCode);
    const [branchName, setBranchName] = useState(labourData.branchName);
    // const [mailId, setMailId] = useState(labourData.mailId);
    const [pfEstNo, setPfEstNo] = useState(labourData.pfEstNo || "");
    const [esiNo, setEsiNo] = useState(labourData.esiNo);
    const [uanNo, setUanNo] = useState(formatIdentifier(labourData.uanNo));
    const [migrantWorkers, setMigrantWorkers] = useState(labourData.migrantWorkers);
    const [highestQualification, setHighestQualification] = useState(labourData.highestQualification || "");
    const [qualificationCertificate, setQualificationCertificate] = useState(labourData.qualificationCertificate || "");
    const [bankPassbook, setBankPassbook] = useState(labourData.bankPassbook || "");
    const [branchList, setBranchList] = useState([{id: "", branchName: ""}]);
    const [contractList, setContractList] = useState([]);
    const [vendorList, setVendorList] = useState([{id: "", vendorName: ""}]);
    const [message, setMessage] = useState("");
    const [labourAge, setLabourAge] = useState(labourData.labourAge);
    const [error, setError] = useState("");
    const [file, setFile] = useState("");
    const [labourImg, setLabourImg] = useState(labourData.labourImg);
    const [unique, setUnique] = useState(false);

    // New states for documents upload
    const [showUploadDocsModal, setShowUploadDocsModal] = useState(false);
    const uploadDocshandleClose = () => setShowUploadDocsModal(false);
    const uploadDocshandleShow = () => setShowUploadDocsModal(true);

    const [aadhaarCardImg, setAadhaarCardImg] = useState(labourData.aadhaarCardImg || "");
    const [ePehchanCardImg, setEPehchanCardImg] = useState(labourData.ePehchanCardImg || labourData.EPehchanCardImg || "");

    const [aadhaarFile, setAadhaarFile] = useState(null);
    const [ePehchanFile, setEPehchanFile] = useState(null);
    // file state is already defined above as 'file'

    const imageUploadRef = React.useRef("");
    const imageUploadNameRef = React.useRef("");

    const [labourImgPreview, setLabourImgPreview] = useState(null);
    const [aadhaarPreview, setAadhaarPreview] = useState(null);
    const [ePehchanPreview, setEPehchanPreview] = useState(null);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const previewObjectUrlsRef = React.useRef([]);

    const trackPreviewObjectUrl = (objectUrl) => {
        if (objectUrl) {
            previewObjectUrlsRef.current.push(objectUrl);
        }
        return objectUrl;
    };

    const revokePreviewObjectUrls = () => {
        previewObjectUrlsRef.current.forEach((objectUrl) => URL.revokeObjectURL(objectUrl));
        previewObjectUrlsRef.current = [];
    };

    useEffect(() => {
        const resolvePreviewUrl = async (fileName) => {
            if (!fileName) {
                return null;
            }
            try {
                const response = await axios.get("labourDocumentPreview", {
                    params: {blobName: fileName},
                    responseType: "blob",
                });
                return {
                    url: trackPreviewObjectUrl(URL.createObjectURL(response.data)),
                    contentType: response.data.type || "",
                };
            } catch (error) {
                console.error(error);
                return null;
            }
        };

        revokePreviewObjectUrls();

        const loadDocumentPreviews = async () => {
            const [labourUrl, aadhaarUrl, ePehchanUrl] = await Promise.all([
                resolvePreviewUrl(labourData.labourImg),
                resolvePreviewUrl(labourData.aadhaarCardImg),
                resolvePreviewUrl(labourData.ePehchanCardImg || labourData.EPehchanCardImg),
            ]);

            setLabourImgPreview(labourUrl);
            setAadhaarPreview(aadhaarUrl);
            setEPehchanPreview(ePehchanUrl);
        };

        loadDocumentPreviews();

        return () => {
            revokePreviewObjectUrls();
        };
    }, [labourData]);

    const onFileChange = (event) => {
        const selectedFile = event.target.files[0];
        if (selectedFile) {
            const allowedTypes = ['image/jpeg', 'image/png'];
            if (!allowedTypes.includes(selectedFile.type)) {
                toast.error("Only JPEG and PNG are allowed for Labour Photo");
                return;
            }
            setFile(selectedFile);
            setLabourImgPreview({
                url: trackPreviewObjectUrl(URL.createObjectURL(selectedFile)),
                contentType: selectedFile.type,
            });
        }
    };

    const onAadhaarFileChange = (event) => {
        const selectedFile = event.target.files[0];
        if (selectedFile) {
            const allowedTypes = ['application/pdf', 'image/jpeg', 'image/png'];
            if (!allowedTypes.includes(selectedFile.type)) {
                toast.error("Only PDF, JPEG, and PNG are allowed for Aadhaar Card");
                return;
            }
            setAadhaarFile(selectedFile);
            setAadhaarPreview({
                url: trackPreviewObjectUrl(URL.createObjectURL(selectedFile)),
                contentType: selectedFile.type,
            });
        }
    };

    const onEPehchanFileChange = (event) => {
        const selectedFile = event.target.files[0];
        if (selectedFile) {
            const allowedTypes = ['application/pdf', 'image/jpeg', 'image/png'];
            if (!allowedTypes.includes(selectedFile.type)) {
                toast.error("Only PDF, JPEG, and PNG are allowed for E-Pehchan Card");
                return;
            }
            setEPehchanFile(selectedFile);
            setEPehchanPreview({
                url: trackPreviewObjectUrl(URL.createObjectURL(selectedFile)),
                contentType: selectedFile.type,
            });
        }
    };

    const renameFile = (originalFile) => {
        const timestamp = Date.now();
        const sanitizedName = originalFile.name.replace(/\s+/g, '_');
        return new File([originalFile], `${timestamp}_${sanitizedName}`, { type: originalFile.type });
    };

    const normalizeNumericField = normalizeOptionalNumericField;

    const buildLabourPayload = (documentOverrides = {}) => ({
        id,
        branchId,
        branch,
        vendorId,
        vendorName,
        contractName,
        labourName,
        labourDob,
        labourDoj,
        labourBloodGroup,
        gender,
        designation,
        adhaarNo: normalizeNumericField(adhaarNo),
        manpower,
        educationalQualification,
        address: emptyToNull(address),
        pinCode: normalizeOptionalNumericField(pinCode),
        contactNumber: emptyToNull(contactNumber),
        altNumber: emptyToNull(altNumber),
        esiNo: normalizeNumericField(esiNo),
        uanNo: normalizeNumericField(uanNo),
        migrantWorkers: emptyToNull(migrantWorkers),
        highestQualification: emptyToNull(highestQualification),
        qualificationCertificate: emptyToNull(qualificationCertificate),
        bankPassbook: emptyToNull(bankPassbook),
        bankState: emptyToNull(bankState),
        bankName: emptyToNull(bankName),
        accountNo: normalizeNumericField(accountNo),
        ifscCode: emptyToNull(ifscCode),
        branchName: emptyToNull(branchName),
        email: emptyToNull(email),
        altEmail: emptyToNull(altEmail),
        pfEstNo: emptyToNull(pfEstNo),
        labourId,
        status,
        labourAge,
        labourImg: emptyToNull(documentOverrides.labourImg ?? labourImg),
        aadhaarCardImg: emptyToNull(documentOverrides.aadhaarCardImg ?? aadhaarCardImg),
        ePehchanCardImg: emptyToNull(documentOverrides.ePehchanCardImg ?? ePehchanCardImg),
    });

    const uploadDocuments = async () => {
        if (isSubmitting) return;
        setIsSubmitting(true);
        try {
            let newLabourImg = labourImg;
            let newAadhaarCardImg = aadhaarCardImg;
            let newEPehchanCardImg = ePehchanCardImg;

            if (file) {
                const renamedFile = renameFile(file);
                const formData = new FormData();
                formData.append("file", renamedFile);
                const res = await axios.post("upload", formData);
                newLabourImg = res.data || renamedFile.name;
                setLabourImg(newLabourImg);
            }
            if (aadhaarFile) {
                const renamedFile = renameFile(aadhaarFile);
                const formData = new FormData();
                formData.append("file", renamedFile);
                const res = await axios.post("upload", formData);
                newAadhaarCardImg = res.data || renamedFile.name;
                setAadhaarCardImg(newAadhaarCardImg);
            }
            if (ePehchanFile) {
                const renamedFile = renameFile(ePehchanFile);
                const formData = new FormData();
                formData.append("file", renamedFile);
                const res = await axios.post("upload", formData);
                newEPehchanCardImg = res.data || renamedFile.name;
                setEPehchanCardImg(newEPehchanCardImg);
            }

            const updatedLabourData = buildLabourPayload({
                labourImg: newLabourImg,
                aadhaarCardImg: newAadhaarCardImg,
                ePehchanCardImg: newEPehchanCardImg,
            });

            await axios.put("updateLabourerMasterDetails/" + id, updatedLabourData);
            
            toast.success("Documents uploaded and saved successfully");
            uploadDocshandleClose();
        } catch (err) {
            console.error(err);
            toast.error(getSafeErrorMessage(err?.response?.data?.msg, "Error uploading or saving documents"));
        } finally {
            setIsSubmitting(false);
        }
    };


    function formatDateForInput(dateStr) {
        const date = new Date(dateStr);
        if (isNaN(date)) return ""; // Handle invalid date
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");
        return `${year}-${month}-${day}`;
    }

    useEffect(() => {
        AOS.init();
        getVendorMasterDetailsByBranch(branchId);
    }, [])


    const calculate_age = (dob) => {
        var today = new Date();
        var birthDate = new Date(dob);
        var age_now = today.getFullYear() - birthDate.getFullYear();
        var m = today.getMonth() - birthDate.getMonth();
        if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
            age_now--;
        }

        setLabourAge(age_now);
    };

    const onSelectDOB = (e) => {
        setLabourDob(e.target.value);
        calculate_age(e.target.value);
    };


    const errorCheck = (e) => {
        const parsedAadhar = parseInt(adhaarNo, 10);
        if (String(vendorId).trim().length === 0 || labourName.trim().length === 0 || labourAge <= 18 || labourAge >= 80 ||
            (gender.toLowerCase() != "male" && gender.toLowerCase() != "female") || labourDoj == "" || labourBloodGroup.trim().length == 0 ||
            designation.trim().length == 0 || educationalQualification.trim().length == 0 || isNaN(parsedAadhar) || String(adhaarNo).trim().length !== 12 ||
            manpower.trim().length == 0
            // || address.trim().length == 0 || pinCode.length != 6 || !contactNumber.match("[0-9]") || altNumber === contactNumber || email.length == 0 ||
            // altEmail === email || pfEstNo.trim().length == 0 || esiNo.length == 0 || bankState.trim().length == 0 ||
            // bankName.trim().length == 0 || accountNo.length < 5 || accountNo.length > 18 || ifscCode.trim().length == 0
            // || branchName.trim().length == 0
        ) {
            setError(true);
            window.scrollTo({
                top: 0, behavior: "smooth",
            });
        } else {
            handleClickConfirm(e);
        }
    };

    const handleClickConfirm = (e) => {
        confirmAlert({
            title: <p className="alertTitle">Confirm to submit</p>, message: (<p className="alertMessage">
                Click on Proceed to Update the Labour Details
            </p>), buttons: [{
                label: "Proceed", onClick: () => updateUser(e),
            }, {
                label: "Cancel",
            },],
        });
    };

    const sucessMessage = () => {
        confirmAlert({
            title: <p className="alertTitle">Updated Successfully</p>,
            message: <img src={CheckInimg} className="successImg" alt=""/>,
            buttons: [{
                label: "Close Page",
            },],
        });
        HandleEvent(2);
    };

    const updateUser = (e) => {
        e.preventDefault();
        setUnique(false);
        const updatedLabourData = buildLabourPayload();

        axios.put("updateLabourerMasterDetails/" + id, updatedLabourData)
            .then((data) => {
                console.log(data)
                if (data.status === 200) {
                    sucessMessage();
                    setShowMsgLE(true);
                }
                if (data?.response?.status === 409) {
                    console.log(data?.response?.data?.msg)
                    if (data?.response?.data?.msg) {
                        toast.error(getSafeErrorMessage(data.response.data.msg))
                        window.scrollTo({
                            top: 0, behavior: "smooth",
                        });
                    }
                }
            })
            .catch(e => {
                console.log(e);
                toast.error(getSafeErrorMessage(e?.response?.data?.msg, "Failed to update labour details"));
            })
    };

    const onSelectVendorShift = (e) => {
        const selectedOption = e.target.selectedOptions[0];
        setVendorId(e.target.value);
        setVendorName(selectedOption.id);
        setContractName(selectedOption.innerText);
        // setVendorName(e.target.selectedOptions[0].id);
        // let newArr = [...resultArray];
        // newArr[i].vendorId = e.target.value;
        // newArr[i].vendorName = e.target.selectedOptions[0].id;
        // setResultArray(newArr);
        // setDraftData(true);
    };

    const getVendorMasterDetailsByBranch = (branchId) => {
        axios
            .get("getVendorMasterDetailsByBranchId/" + branchId)
            .then((data) => {
                if (data.status === 200) {
                    const vendorList = data.data;

                    setVendorList(vendorList);
                } else {
                    // window.location.href = "/error"
                }
            })
            .catch((error) => {
                console.error(error);

                // window.location.href = "/error"
            });
    };

    return (<div>
        <Container fluid className="px-0">
            <div className="">
                <div className={"mt-2"}>
                    {/*<h2>Laborer Master</h2>*/}
                    <h5 className={"priColor"}>Edit Laborer Master</h5>
                </div>
                <div data-aos="zoom-in-right" data-aos-duration="450">
                    <Form>
                        <Card className="cardStyl">
                            {/* <div> */}
                            <Navbar bg="white" className="mb-3">
                                <Container fluid className="px-0">
                                    <Navbar.Brand style={{fontWeight: "500"}}>
                                        Personal Information
                                    </Navbar.Brand>
                                    <Navbar.Toggle/>
                                    <Navbar.Offcanvas
                                        id="id2"
                                        aria-labelledby="id1"
                                        placement="end"
                                    >
                                        <Offcanvas.Body>
                                            {/* <Nav className="justify-content-end flex-grow-1 pe-3">
                        <NavDropdown
                          title="Select Branch"
                          id='id1'
                        >
                          <NavDropdown.Item href="#action3">Erode</NavDropdown.Item>
                          <NavDropdown.Item href="#action4">
                            Plant1
                          </NavDropdown.Item>
                          <NavDropdown.Item href="#action5">
                            Plant2
                          </NavDropdown.Item>
                           <NavDropdown.Divider />
                          <NavDropdown.Item href="#action5">
                            Plant2
                          </NavDropdown.Item>
                          <NavDropdown.Divider />
                        </NavDropdown>
                      </Nav> */}
                                        </Offcanvas.Body>
                                    </Navbar.Offcanvas>
                                </Container>
                            </Navbar>
                            <div>
                                {/* <Row className="mb-3">
                  <Col xs={6}>
                    <Row>
                      <Form.Label column lg={4} className="labelRight">
                        Branch<sup className="required">*</sup>
                      </Form.Label>
                      <Col lg={8}>
                        <Form.Select
                          // name={deptList}
                          // onChange={(e) => setBranch(e.target.value)}
                          onChange={(e) => onSelectBranch(e)}
                          value = {branch}
                        >
                          <option key= "defaultOption" value="defaultOption">Select Branch</option>
                          {branchList.map(branch => (
                            <option
                              key={branch.id}
                              value={branch.branchName}
                            >
                              {branch.branchName}
                            </option>
                          ))}
                        </Form.Select>
                        {error&& (branch == "defaultOption")?
                        <label className="requiredValidation">Please Select Branch </label>:""}
                        {/* {errors.Dept && (
                          <p className="RequiredFields">Please Select Dept</p>
                        )}
                      </Col>
                    </Row>
                  </Col>
                </Row> */}
                                {/*<Row className='mb-3'>*/}
                                {/*    <Col md={6} sm={12} xl={6} lg={6}>*/}
                                {/* <Row>
                      <Form.Label column md={4} sm={4} xl={4} lg={4} className="labelRight">Contract Name<sup className='required'>*</sup></Form.Label>
                      <Col>
                      <Form.Select
                          onChange={(e) => onSelectContractName(e)}
                          value ={contractName}
                        >
                        <option value="defaultOption">Select Contract Name</option>
                        {
                        contractList.map(contractName =>
                          (
                           <option key={contractName.id} value={contractName.contractName}>
                           {contractName.contractName}
                        </option>
                        ))}
                        </Form.Select>
                        {error&& (contractName == "defaultOption")?
                        <label className="requiredValidation">Please Select Contract Name </label>:""}
                        {/* {...register("contractName", { required: true, maxLength: 10 })}
                      {errors.contractName && <p className='validationMsg valdiationMsgAlign'>Please Check the Contract Name</p>}
                      </Col>
                    </Row>
                  </Col>*/}
                                {!localStorage.getItem("vendorId") && <Row className='mb-3'>
                                    <Col md={6} sm={12} xl={6} lg={6}>
                                        <Row>
                                            <Form.Label column md={4} sm={4} xl={4} lg={4} className="labelRight">Vendor
                                                Name<sup className='required'>*</sup></Form.Label>
                                            <Col>
                                                <Form.Select
                                                    aria-label="Default select example subDepartmentList"
                                                    onChange={(e) => onSelectVendorShift(e)}
                                                    key={vendorId}
                                                    value={vendorId}
                                                >
                                                    <option value="" key={""}
                                                            id={""}>
                                                        Select Vendor
                                                    </option>
                                                    {vendorList.map((vendor) => (<option
                                                        key={vendor.id}
                                                        value={vendor.id}
                                                        id={vendor.vendorName}
                                                    >
                                                        {vendor.contractName}
                                                    </option>))}
                                                </Form.Select>
                                                {error && (String(vendorId).trim().length <= 0)?
                                                    <label className="requiredValidation">Please Select Vendor Name </label>:""}
                                                {/* {error&&vendorName.trim().length<=0?
                        <label className="requiredValidation">Vendor Name Can't be empty</label>:""}
                        {/*   {...register("contractorName", { required: true, maxLength: 30 })}
                      {errors.contractorName && <p className='validationMsg valdiationMsgAlign'>Please Check the Contractor Name</p>} */}
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>}
                                <Row className="mb-3">
                                    <Col md={6} sm={12} xl={6} lg={6}>
                                        <Row>
                                            <Form.Label
                                                column
                                                md={4}
                                                sm={4}
                                                xl={4}
                                                lg={4}
                                                className="labelRight"
                                            >
                                                Labour Name<sup className="required">*</sup>
                                            </Form.Label>
                                            <Col>
                                                <Form.Control
                                                    type="text"
                                                    placeholder="Enter here.."
                                                    onChange={(e) => setLabourName(e.target.value)}
                                                    value={labourName}
                                                />
                                                {error && labourName.trim().length <= 0 ? (
                                                    <label className="requiredValidation">
                                                        Labour Name Can't be empty
                                                    </label>) : ("")}
                                                {/*{errors.laborerName && <p className='validationMsg valdiationMsgAlign'>Please Check the Laborer Name</p>}*/}
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col md={6} sm={12} xl={6} lg={6}>
                                        <Row>
                                            <Form.Label
                                                column
                                                md={4}
                                                sm={4}
                                                xl={4}
                                                lg={4}
                                                className="labelRight"
                                            >
                                                Labour ID<sup className="required">*</sup>
                                            </Form.Label>
                                            <Col>
                                                <Form.Control
                                                    type="text"
                                                    placeholder="Enter here.."
                                                    onChange={(e) => setLabourId(e.target.value)}
                                                    value={labourId}
                                                />
                                                {error && labourId.trim().length <= 0 ? (
                                                    <label className="requiredValidation">
                                                        Labour ID Can't be empty
                                                    </label>) : ("")}
                                                {/*{errors.laborerName && <p className='validationMsg valdiationMsgAlign'>Please Check the Laborer Name</p>}*/}
                                            </Col>
                                        </Row>
                                    </Col>
                                    {/* <Col md={6} sm={12} xl={6} lg={6}>
                    <Row>
                      <Form.Label column md={4} sm={4} xl={4} lg={4} className="labelRight">Add Image<sup className='required'>*</sup></Form.Label>
                      <Col>
                        <Form.Control disabled
                          type="text"
                          placeholder="Upload Image"
                          onChange={(e) => setAddImage(e.target.value)}
                          value = {addImage} />

                      </Col>
                    </Row>
                  </Col> */}
                                </Row>
                                <Row className="mb-3">
                                    <Col md={6} sm={12} xl={6} lg={6}>
                                        <Row>
                                            <Form.Label
                                                column
                                                md={4}
                                                sm={4}
                                                xl={4}
                                                lg={4}
                                                className="labelRight"
                                            >
                                                Labour DOB<sup className="required">*</sup>
                                            </Form.Label>
                                            <Col>
                                                <Form.Control
                                                    type="date"
                                                    // max="2010-12-31"
                                                    placeholder="Enter here.."
                                                    onChange={(e) => onSelectDOB(e)}
                                                    value={labourDob}
                                                />
                                                {error && (labourAge <= 18 || labourAge >= 80) ? (
                                                    <label className="requiredValidation">
                                                        Please Select Valid DOB
                                                    </label>) : ("")}
                                                {/* {...register("laborerDob", { required: true, pattern: /^(0[1-9]|1[0-9]|2[0-9]|3[0-1])\/(0[1-9]|1[0-2])\/([0-9]{4})$/ })} />
                        {errors.laborerDob && <p className='validationMsg valdiationMsgAlign'>Please Check the Laborer DOB</p>}*/}
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col md={6} sm={12} xl={6} lg={6}>
                                        <Row>
                                            <Form.Label
                                                column
                                                md={4}
                                                sm={4}
                                                xl={4}
                                                lg={4}
                                                className="labelRight"
                                            >
                                                Labourer Age<sup className="required">*</sup>
                                            </Form.Label>
                                            <Col>
                                                <Form.Control
                                                    disabled
                                                    type="text"
                                                    placeholder="Age"
                                                    value={labourAge}
                                                    onChange={(e) => setLabourAge(e.target.value)}
                                                    // {...register("contractorAge", { required: true })}
                                                />
                                                {/* {errors.contractorAge && <p className='validationMsg valdiationMsgAlign valdiationMsgAlign valdiationMsgAlign valdiationMsgAlign valdiationMsgAlign'>Contractor Age Required</p>} */}
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>

                                <Row className="mb-3">
                                    <Col md={6} sm={12} xl={6} lg={6}>
                                        <Form.Group as={Row}>
                                            <Form.Label
                                                column
                                                md={4}
                                                sm={4}
                                                xl={4}
                                                lg={4}
                                                className="labelRight"
                                            >
                                                Gender<sup className="required">*</sup>
                                            </Form.Label>
                                            <Col className="mt-2">
                                                <div className="inlineflex">
                                                    <div className="mrgnGender">
                                                        <Form.Check
                                                            checked={gender.toLowerCase() === "male"}
                                                            value="male"
                                                            type="radio"
                                                            name="gender"
                                                            aria-label="radio 1"
                                                            label="Male"
                                                            onChange={(e) => setGender(e.target.value)}
                                                        />
                                                    </div>
                                                    <div className="mrgnGender">
                                                        <Form.Check
                                                            checked={gender.toLowerCase() === "female"}
                                                            value="female"
                                                            type="radio"
                                                            name="gender"
                                                            aria-label="radio 2"
                                                            label="Female"
                                                            onChange={(e) => setGender(e.target.value)}
                                                        />
                                                    </div>
                                                    {/* <div className="mrgnGender">
                            <Form.Check value="other" type="radio" name="gender" aria-label="radio 3" label="Other" onChange={(e) => setGender(e.target.value)} />
                          </div> */}
                                                </div>
                                                {error && gender.toLowerCase() != "male" && gender.toLowerCase() != "female" ? (
                                                    <label className="requiredValidation">
                                                        Please Select Gender
                                                    </label>) : ("")}
                                                {/*{errors.gender && <p className='validationMsg valdiationMsgAlign'>Select the Gender</p>}*/}
                                            </Col>
                                        </Form.Group>
                                    </Col>

                                    <Col md={6} sm={12} xl={6} lg={6}>
                                        <Form.Group as={Row}>
                                            <Form.Label
                                                column
                                                md={4}
                                                sm={4}
                                                xl={4}
                                                lg={4}
                                                className="labelRight"
                                            >
                                                Migrant Workers<sup className="required">*</sup>
                                            </Form.Label>
                                            <Col className="mt-2">
                                                <div className="inlineflex">
                                                    <div className="mrgnGender">
                                                        <Form.Check
                                                            checked={migrantWorkers === "Yes" || migrantWorkers === "YES"}
                                                            value="Yes"
                                                            type="radio"
                                                            name="migrantWorkers"
                                                            aria-label="radio 1"
                                                            label="Yes"
                                                            onChange={(e) => setMigrantWorkers(e.target.value)}
                                                        />
                                                    </div>
                                                    <div className="mrgnGender">
                                                        <Form.Check
                                                            checked={migrantWorkers === "No" || migrantWorkers === "NO"}
                                                            value="No"
                                                            type="radio"
                                                            name="migrantWorkerrs"
                                                            aria-label="radio 2"
                                                            label="No"
                                                            onChange={(e) => setMigrantWorkers(e.target.value)}
                                                        />
                                                    </div>
                                                    {/* <div className="mrgnGender">
                            <Form.Check value="other" type="radio" name="gender" aria-label="radio 3" label="Other" onChange={(e) => setGender(e.target.value)} />
                          </div> */}
                                                </div>
                                                {error && migrantWorkers.toLowerCase() != "yes" && migrantWorkers.toLowerCase() != "no" ? (
                                                    <label className="requiredValidation">
                                                        Please Select Yes/No
                                                    </label>) : ("")}
                                                {/*{errors.gender && <p className='validationMsg valdiationMsgAlign'>Select the Gender</p>}*/}
                                            </Col>
                                        </Form.Group>
                                    </Col>
                                </Row>

                                <Row className="mb-3">
                                    <Col md={6} sm={12} xl={6} lg={6}>
                                        <Row>
                                            <Form.Label
                                                column
                                                md={4}
                                                sm={4}
                                                xl={4}
                                                lg={4}
                                                className="labelRight"
                                            >
                                                {" "}
                                                Labour DOJ<sup className="required">*</sup>
                                            </Form.Label>
                                            <Col>
                                                <Form.Control
                                                    type="date"
                                                    // min="1923-01-01"
                                                    placeholder="Enter here.."
                                                    onChange={(e) => setLabourDoj(e.target.value)}
                                                    value={labourDoj}
                                                />
                                                {error && labourDoj === "" ? (<label className="requiredValidation">
                                                    Please Select Date
                                                </label>) : ("")}
                                                {/*{...register("doj", { required: true, pattern: /^(0[1-9]|1[0-9]|2[0-9]|3[0-1])\/(0[1-9]|1[0-2])\/([0-9]{4})$/ })} />
                        {errors.doj && <p className='validationMsg valdiationMsgAlign'>Please Check the DOJ</p>}*/}
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col md={6} sm={12} xl={6} lg={6}>
                                        <Row>
                                            <Form.Label
                                                column
                                                md={4}
                                                sm={4}
                                                xl={4}
                                                lg={4}
                                                className="labelRight"
                                            >
                                                Labour Blood Group<sup className="required">*</sup>
                                            </Form.Label>
                                            <Col>
                                                <Form.Control
                                                    type="text"
                                                    placeholder="Enter here.."
                                                    onChange={(e) => setLabourBloodGroup(e.target.value)}
                                                    value={labourBloodGroup}
                                                />
                                                {error && labourBloodGroup.trim().length <= 0 ? (
                                                    <label className="requiredValidation">
                                                        Please Enter Blood group
                                                    </label>) : ("")}
                                                {/*{...register("laborerAge", { required: true })} />
                        {errors.laborerAge && <p className='validationMsg valdiationMsgAlign'>Laborer Age Required</p>}*/}
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>

                                <Row className="mb-3">
                                    <Col md={6} sm={12} xl={6} lg={6}>
                                        <Row>
                                            <Form.Label
                                                column
                                                md={4}
                                                sm={4}
                                                xl={4}
                                                lg={4}
                                                className="labelRight"
                                            >
                                                Designation<sup className="required">*</sup>
                                            </Form.Label>
                                            <Col>
                                                <Form.Control
                                                    type="text"
                                                    placeholder="Enter here.."
                                                    onChange={(e) => setDesignation(e.target.value)}
                                                    value={designation}
                                                />
                                                {error && designation.trim().length <= 0 ? (
                                                    <label className="requiredValidation">
                                                        Please Enter Designation
                                                    </label>) : ("")}
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col md={6} sm={12} xl={6} lg={6}>
                                        <Row>
                                            <Form.Label
                                                column
                                                md={4}
                                                sm={4}
                                                xl={4}
                                                lg={4}
                                                className="labelRight"
                                            >
                                                Educational Qualification
                                                <sup className="required">*</sup>
                                            </Form.Label>
                                            <Col>
                                                <Form.Control
                                                    type="text"
                                                    placeholder="Enter here.."
                                                    onChange={(e) => setEducationalQualification(e.target.value)}
                                                    value={educationalQualification}
                                                />
                                                {error && educationalQualification.trim().length <= 0 ? (
                                                    <label className="requiredValidation">
                                                        Please Enter Educational Qualification
                                                    </label>) : ("")}
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                                <Row className="mb-3">
                                    <Col md={6} sm={12} xl={6} lg={6}>
                                        <Row>
                                            <Form.Label
                                                column
                                                md={4}
                                                sm={4}
                                                xl={4}
                                                lg={4}
                                                className="labelRight"
                                            >
                                                Aadhar No<sup className="required">*</sup>
                                            </Form.Label>
                                            <Col>
                                                <Form.Control
                                                    type="number"
                                                    placeholder="Enter here.."
                                                    onChange={(e) => setAdhaarNo(e.target.value)}
                                                    value={adhaarNo}
                                                />
                                                {error && ((isNaN(parseInt(adhaarNo, 10))) || String(adhaarNo).trim().length !== 12)  ? (
                                                    <label className="requiredValidation">
                                                        Please Enter Aadhar Number
                                                    </label>) : ("")}
                                                {unique === true ?
                                                    <label className="requiredValidation">
                                                        Aadhar Number already exists
                                                    </label> : ("")
                                                }
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col md={6} sm={12} xl={6} lg={6}>
                                        <Row>
                                            <Form.Label
                                                column
                                                md={4}
                                                sm={4}
                                                xl={4}
                                                lg={4}
                                                className="labelRight"
                                            >
                                                Fixed Manpower or variable Manpower
                                                <sup className="required">*</sup>
                                            </Form.Label>
                                            <Col>
                                                <Form.Control
                                                    type="text"
                                                    placeholder="Enter here.."
                                                    onChange={(e) => setManpower(e.target.value)}
                                                    value={manpower}
                                                />
                                                {error && manpower.trim().length <= 0 ? (
                                                    <label className="requiredValidation">
                                                        Please Enter
                                                    </label>) : ("")}
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                                <Row className="mb-3">
                                    <Col md={6} sm={12} xl={6} lg={6}>
                                        <Row>
                                            <Form.Label
                                                column
                                                md={4}
                                                sm={4}
                                                xl={4}
                                                lg={4}
                                                className="labelRight"
                                            >
                                                Address
                                                {/*<sup className="required">*</sup>*/}
                                            </Form.Label>
                                            <Col>
                          <textarea
                              className="form-control"
                              placeholder="Enter here.."
                              onChange={(e) => setAddress(e.target.value)}
                              value={address}
                          />
                                                {error && address.trim().length <= 0 ? (
                                                    <label className="requiredValidation">
                                                        Please Enter Address
                                                    </label>) : ("")}
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col md={6} sm={12} xl={6} lg={6}>
                                        <Row>
                                            <Form.Label
                                                column
                                                md={4}
                                                sm={4}
                                                xl={4}
                                                lg={4}
                                                className="labelRight"
                                            >
                                                Pincode
                                                {/*<sup className="required">*</sup>*/}
                                            </Form.Label>
                                            <Col>
                                                <Form.Control
                                                    type="number"
                                                    placeholder="Enter here.."
                                                    onChange={(e) => setPinCode(e.target.value)}
                                                    value={pinCode}
                                                />
                                                {error && pinCode.length != 6 ? (<label className="requiredValidation">
                                                    Please Enter Valid Pincode
                                                </label>) : ("")}
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                                <Row className="mb-3">
                                    <Col md={6} sm={12} xl={6} lg={6}>
                                        <Row>
                                            <Form.Label
                                                column
                                                md={4}
                                                sm={4}
                                                xl={4}
                                                lg={4}
                                                className="labelRight"
                                            >
                                                Contact Number
                                                {/*<sup className="required">*</sup>*/}
                                            </Form.Label>
                                            <Col>
                                                <Form.Control
                                                    type="number"
                                                    placeholder="Enter here.."
                                                    onChange={(e) => setContactNumber(e.target.value)}
                                                    value={contactNumber}
                                                />
                                                {error && contactNumber.length != 10 ? (
                                                    <label className="requiredValidation">
                                                        Please Enter Valid Contact Number
                                                    </label>) : ("")}
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col md={6} sm={12} xl={6} lg={6}>
                                        <Row>
                                            <Form.Label
                                                column
                                                md={4}
                                                sm={4}
                                                xl={4}
                                                lg={4}
                                                className="labelRight"
                                            >
                                                Alternative Number
                                                {/* <sup className='required'>*</sup> */}
                                            </Form.Label>
                                            <Col>
                                                <Form.Control
                                                    type="number"
                                                    placeholder="Enter here.."
                                                    onChange={(e) => setAltNumber(e.target.value)}
                                                    value={altNumber}
                                                />
                                                {error && altNumber === contactNumber && contactNumber.length == 10 ? (
                                                    <label className="requiredValidation">
                                                        This Number was already Provided in "Contact
                                                        Number", Please Enter New Number or Make it empty.
                                                    </label>) : ("")}
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                                <Row className="mb-3">
                                    <Col md={6} sm={12} xl={6} lg={6}>
                                        <Row>
                                            <Form.Label
                                                column
                                                md={4}
                                                sm={4}
                                                xl={4}
                                                lg={4}
                                                className="labelRight"
                                            >
                                                Email Id
                                                {/*<sup className="required">*</sup>*/}
                                            </Form.Label>
                                            <Col>
                                                <Form.Control
                                                    type="email"
                                                    placeholder="name@example.com"
                                                    onChange={(e) => setEmail(e.target.value)}
                                                    value={email}
                                                />
                                                {error && email.length <= 0 ? (<label className="requiredValidation">
                                                    Please Enter Valid Email Id
                                                </label>) : ("")}
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col md={6} sm={12} xl={6} lg={6}>
                                        <Row>
                                            <Form.Label
                                                column
                                                md={4}
                                                sm={4}
                                                xl={4}
                                                lg={4}
                                                className="labelRight"
                                            >
                                                Alternative Email Id
                                                {/* <sup className='required'>*</sup> */}
                                            </Form.Label>
                                            <Col>
                                                <Form.Control
                                                    type="email"
                                                    placeholder="name@example.com"
                                                    onChange={(e) => setAltEmail(e.target.value)}
                                                    value={altEmail}
                                                />
                                                {error && altEmail === email && email.length != 0 ? (
                                                    <label className="requiredValidation">
                                                        This Id was already Provided in "Email Id", Please
                                                        enter another Id or make it empty.{" "}
                                                    </label>) : ("")}
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                                <Row className="mb-3">
                                    <Col md={6} sm={12} xl={6} lg={6}>
                                        <Row>
                                            <Form.Label
                                                column
                                                md={4}
                                                sm={4}
                                                xl={4}
                                                lg={4}
                                                className="labelRight"
                                            >
                                                Bank State
                                                {/*<sup className="required">*</sup>*/}
                                            </Form.Label>
                                            <Col>
                                                <Form.Control
                                                    type="text"
                                                    placeholder="Enter here.."
                                                    onChange={(e) => setBankState(e.target.value)}
                                                    value={bankState}
                                                />
                                                {error && bankState.length <= 0 ? (
                                                    <label className="requiredValidation">
                                                        Please Enter Bank State
                                                    </label>) : ("")}
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col md={6} sm={12} xl={6} lg={6}>
                                        <Row>
                                            <Form.Label
                                                column
                                                md={4}
                                                sm={4}
                                                xl={4}
                                                lg={4}
                                                className="labelRight"
                                            >
                                                Bank Name
                                                {/*<sup className="required">*</sup>*/}
                                            </Form.Label>
                                            <Col>
                                                <Form.Control
                                                    type="text"
                                                    placeholder="Enter here.."
                                                    onChange={(e) => setBankName(e.target.value)}
                                                    value={bankName}
                                                />
                                                {error && bankName.length <= 0 ? (<label className="requiredValidation">
                                                    Please Enter Bank Name
                                                </label>) : ("")}
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                                <Row className="mb-3">
                                    <Col md={6} sm={12} xl={6} lg={6}>
                                        <Row>
                                            <Form.Label
                                                column
                                                md={4}
                                                sm={4}
                                                xl={4}
                                                lg={4}
                                                className="labelRight"
                                            >
                                                Account Number
                                                {/*<sup className="required">*</sup>*/}
                                            </Form.Label>
                                            <Col>
                                                <Form.Control
                                                    type="number"
                                                    placeholder="Enter here.."
                                                    onChange={(e) => setAccountNo(e.target.value)}
                                                    value={accountNo}
                                                />
                                                {error && (accountNo?.length < 5 || accountNo?.length > 18) ? (
                                                    <label className="requiredValidation">
                                                        Please Enter Valid Account Number
                                                    </label>) : ("")}
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col md={6} sm={12} xl={6} lg={6}>
                                        <Row>
                                            <Form.Label
                                                column
                                                md={4}
                                                sm={4}
                                                xl={4}
                                                lg={4}
                                                className="labelRight"
                                            >
                                                IFSC Code
                                                {/*<sup className="required">*</sup>*/}
                                            </Form.Label>
                                            <Col>
                                                <Form.Control
                                                    type="text"
                                                    placeholder="Enter here.."
                                                    onChange={(e) => setIfscCode(e.target.value)}
                                                    value={ifscCode}
                                                />
                                                {error && ifscCode?.trim().length <= 0 ? (
                                                    <label className="requiredValidation">
                                                        Please Enter IFSC Code{" "}
                                                    </label>) : ("")}
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                                <Row className="mb-3">
                                    <Col md={6} sm={12} xl={6} lg={6}>
                                        <Row>
                                            <Form.Label
                                                column
                                                md={4}
                                                sm={4}
                                                xl={4}
                                                lg={4}
                                                className="labelRight"
                                            >
                                                Branch Name
                                                {/*<sup className="required">*</sup>*/}
                                            </Form.Label>
                                            <Col>
                                                <Form.Control
                                                    type="text"
                                                    placeholder="Enter here.."
                                                    onChange={(e) => setBranchName(e.target.value)}
                                                    value={branchName}
                                                />
                                                {error && branchName?.trim().length <= 0 ? (
                                                    <label className="requiredValidation">
                                                        Please Enter Branch Name{" "}
                                                    </label>) : ("")}
                                            </Col>
                                        </Row>
                                    </Col>
                                    {/* <Col md={6} sm={12} xl={6} lg={6}>
                    <Row>
                      <Form.Label column md={4} sm={4} xl={4} lg={4} className="labelRight">Mail Id<sup className='required'>*</sup></Form.Label>
                      <Col>
                        <Form.Control
                          type="email"
                          disabled
                          placeholder="name@example.com"
                          onChange={(e) => setMailId(e.target.value)}
                          value={mailId} />
                      </Col>
                    </Row>
                  </Col> */}
                                    <Col md={6} sm={12} xl={6} lg={6}>
                                        <Row>
                                            <Form.Label
                                                column
                                                md={4}
                                                sm={4}
                                                xl={4}
                                                lg={4}
                                                className="labelRight"
                                            >
                                                ESI NO
                                                {/*<sup className="required">*</sup>*/}
                                            </Form.Label>
                                            <Col>
                                                <Form.Control
                                                    type="number"
                                                    placeholder="Enter here.."
                                                    onChange={(e) => setEsiNo(e.target.value)}
                                                    value={esiNo}
                                                />
                                                {error && esiNo?.length <= 0 ? (<label className="requiredValidation">
                                                    Please Enter Esi No.{" "}
                                                </label>) : ("")}
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                                <Row className="mb-3">
                                    <Col md={6} sm={12} xl={6} lg={6}>
                                        <Row>
                                            <Form.Label
                                                column
                                                md={4}
                                                sm={4}
                                                xl={4}
                                                lg={4}
                                                className="labelRight"
                                            >
                                                PF Establishment Number
                                                {/*<sup className="required">*</sup>*/}
                                            </Form.Label>
                                            <Col>
                                                <Form.Control
                                                    type="text"
                                                    placeholder="Enter here.."
                                                    onChange={(e) => setPfEstNo(e.target.value)}
                                                    value={pfEstNo}
                                                />
                                                {error && pfEstNo?.trim().length <= 0 ? (
                                                    <label className="requiredValidation">
                                                        Please Enter PF Est No.
                                                    </label>) : ("")}
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col md={6} sm={12} xl={6} lg={6}>
                                        <Row>
                                            <Form.Label
                                                column
                                                md={4}
                                                sm={4}
                                                xl={4}
                                                lg={4}
                                                className="labelRight"
                                            >
                                                UAN NO
                                                {/*<sup className="required">*</sup>*/}
                                            </Form.Label>
                                            <Col>
                                                <Form.Control
                                                    type="text"
                                                    inputMode="numeric"
                                                    placeholder="Enter here.."
                                                    onChange={(e) => setUanNo(e.target.value.replace(/\D/g, ""))}
                                                    value={uanNo}
                                                />
                                                {error && uanNo?.length <= 0 ? (<label className="requiredValidation">
                                                    Please Enter UAN No.{" "}
                                                </label>) : ("")}
                                            </Col>
                                        </Row>
                                    </Col>
                                    {/* <Col md={6} sm={12} xl={6} lg={6}>
                    <Row>
                      <Form.Label column md={4} sm={4} xl={4} lg={4} className="labelRight">ESI NO<sup className='required'>*</sup></Form.Label>
                      <Col>
                        <Form.Control
                          type="text"
                          placeholder="Enter here.."
                          onChange={(e) => setEsiNo(e.target.value)}
                          value={esiNo} />
                          {error&&esiNo.trim().length<=0?
                        <label className="requiredValidation">Please Enter Esi No. </label>:""}
                      </Col>
                    </Row>
                  </Col> */}
                                </Row>
                                <Row className="mb-3">
                                    <Col md={12}>
                                        <h5 className="mb-3 mt-3">Document Previews</h5>
                                    </Col>
                                    <Col md={4} className="text-center">
                                        <label className="d-block mb-2">Labour Photo</label>
                                        {renderDocumentPreview(labourImgPreview, labourImg, "Labour Photo", "No Image")}
                                    </Col>
                                    <Col md={4} className="text-center">
                                        <label className="d-block mb-2">Aadhaar Card</label>
                                        {renderDocumentPreview(aadhaarPreview, aadhaarCardImg, "Aadhaar Card")}
                                    </Col>
                                    <Col md={4} className="text-center">
                                        <label className="d-block mb-2">E-Pehchan Card</label>
                                        {renderDocumentPreview(ePehchanPreview, ePehchanCardImg, "E-Pehchan Card")}
                                    </Col>
                                </Row>
                                <div className="SaveCancelButtonDiv">
                                    <div className="container">
                                        <div className="row">
                                            <div className="text-right">
                                                {/* <button type="button" className="btn btn-primary float-end mx-2">Cancel</button>  */}
                                                {/* <button type="submit" className="btn btn-success float-end">Proceed</button> */}
                                                <button
                                                    type="button"
                                                    className="btn btn-primary float-end mx-2"
                                                    onClick={(e) => errorCheck(e)}
                                                >
                                                    Update User
                                                </button>
                                                <button
                                                    type="button"
                                                    className="btn btn-primary float-end mx-2"
                                                    onClick={uploadDocshandleShow}
                                                >
                                                    Upload Documents
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Card>
                    </Form>
                </div>
            </div>
        </Container>
        <Modal
            show={showUploadDocsModal}
            onHide={uploadDocshandleClose}
            backdrop="static"
            keyboard={false}
        >
            <Modal.Header closeButton>
                <Modal.Title>Upload Documents</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Row>
                    <Col md={12} sm={12} xl={12} lg={12}>
                        <Row>
                            <Form.Label column md={4} className="labelRight">
                                Labour Photo
                            </Form.Label>
                            <Col>
                                {labourImgPreview && (
                                    <div className="mt-2 mb-2">
                                        <label className="mb-1">Current Photo:</label>
                                        <div className="d-block">
                                            {renderDocumentPreview(labourImgPreview, labourImg, "Labour Photo", "No Image")}
                                        </div>
                                    </div>
                                )}
                                <Form.Group controlId="formFile" className="mb-3">
                                    <Form.Control
                                        type="file"
                                        onChange={onFileChange}
                                        accept="image/png, image/jpeg"
                                    />
                                    <Form.Text className="text-muted">
                                        Allowed: PNG, JPEG
                                    </Form.Text>
                                </Form.Group>
                            </Col>
                        </Row>
                    </Col>
                </Row>
                <Row>
                    <Col md={12} sm={12} xl={12} lg={12}>
                        <Row>
                            <Form.Label column md={4} className="labelRight">
                                Aadhaar Card
                            </Form.Label>
                            <Col>
                                {aadhaarPreview && (
                                    <div className="mb-2">
                                        <label className="mb-1 d-block">Current Aadhaar:</label>
                                        {renderDocumentPreview(aadhaarPreview, aadhaarCardImg, "Aadhaar Card")}
                                    </div>
                                )}
                                <Form.Group controlId="formFileAadhaar" className="mb-3">
                                    <Form.Control
                                        type="file"
                                        onChange={onAadhaarFileChange}
                                        accept="application/pdf, image/png, image/jpeg"
                                    />
                                    <Form.Text className="text-muted">
                                        Allowed: PDF, PNG, JPEG
                                    </Form.Text>
                                </Form.Group>
                            </Col>
                        </Row>
                    </Col>
                </Row>
                <Row>
                    <Col md={12} sm={12} xl={12} lg={12}>
                        <Row>
                            <Form.Label column md={4} className="labelRight">
                                E-Pehchan Card
                            </Form.Label>
                            <Col>
                                {ePehchanPreview && (
                                    <div className="mb-2">
                                        <label className="mb-1 d-block">Current E-Pehchan:</label>
                                        {renderDocumentPreview(ePehchanPreview, ePehchanCardImg, "E-Pehchan Card")}
                                    </div>
                                )}
                                <Form.Group controlId="formFileEPehchan" className="mb-3">
                                    <Form.Control
                                        type="file"
                                        onChange={onEPehchanFileChange}
                                        accept="application/pdf, image/png, image/jpeg"
                                    />
                                    <Form.Text className="text-muted">
                                        Allowed: PDF, PNG, JPEG
                                    </Form.Text>
                                </Form.Group>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={uploadDocshandleClose}>
                    Close
                </Button>
                <Button variant="primary" onClick={uploadDocuments} disabled={isSubmitting}>
                    {isSubmitting ? 'Saving...' : 'Save & Upload'}
                </Button>
            </Modal.Footer>
        </Modal>
        <Modal
            show={showLE}
            onHide={handleClose}
            backdrop="static"
            keyboard={false}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header className="modal-header">
                <Modal.Title>Confirm Update User</Modal.Title>
            </Modal.Header>
            {showMsgLE == "" && (<Modal.Body>Please click on "Update User" to update user.</Modal.Body>)}
            {showMsgLE != "" && (<Modal.Body>
                <img src={CheckInimg} className="check-in-img" alt=""/> <br></br>
                <h5>User updated Successfully !!</h5>
            </Modal.Body>)}
            <Modal.Footer>
                {showMsgLE == "" && (<Button variant="secondary" onClick={handleClose}>
                    Close
                </Button>)}
                {showMsgLE != "" && (<Button variant="secondary" onClick={handleBack}>
                    Back
                </Button>)}
                {showMsgLE == "" && (<Button
                    type="button"
                    variant="primary"
                    onClick={(e) => updateUser(e)}
                >
                    Update User
                </Button>)}
            </Modal.Footer>
        </Modal>
    </div>);
}

export default EditLaborerMaster;
